import { render } from "./MaterialVendorStockBlockComponent.vue?vue&type=template&id=3049d668"
import script from "./MaterialVendorStockBlockComponent.vue?vue&type=script&lang=js"
export * from "./MaterialVendorStockBlockComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__